"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by david.petrosyan on 10/09/18.
 */
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var entity_search_item_1 = require("../../model/entity-search-item");
var response_data_model_1 = require("../../model/response-data.model");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var serialization_helper_1 = require("./serialization-helper");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var main_entity_model_1 = require("../../model/main-entity.model");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var entity_service_1 = require("../api/entity.service");
var EntitySearchHelperService = /** @class */ (function () {
    function EntitySearchHelperService(_kbService, _languageService, _classifierService, _entitySearchService) {
        this._kbService = _kbService;
        this._languageService = _languageService;
        this._classifierService = _classifierService;
        this._entitySearchService = _entitySearchService;
        this.loadedClassifiers = new Map();
        this.systemNameMetaFields = new Map();
        this.classifiersValueIds = new Map();
        this.mainEntityDeSerializedData = new Map();
        this.compoundMainEntityMetaFieldsMap = new Map();
        this._entityBuilder = new idm_de_core_frontend_1.EntityBuilder();
    }
    EntitySearchHelperService_1 = EntitySearchHelperService;
    EntitySearchHelperService.prototype.extractEntitySearchItems = function (entitySearchItemsData$, filterFields, multilingualFields, nameFieldIds, languageId, categoryIdentityFieldSystemName) {
        var _this = this;
        return entitySearchItemsData$.map(function (entitiesData) {
            var responseData = new response_data_model_1.ResponseData();
            var searchItems = [];
            if (entitiesData.data.length > 0) {
                searchItems = _this.getEntityDisplayNameFromResponse(entitiesData.data, filterFields, multilingualFields, nameFieldIds, languageId, categoryIdentityFieldSystemName);
            }
            responseData.setTotalRowCount(entitiesData.meta.totalRowCount);
            responseData.setData(searchItems);
            return responseData;
        });
    };
    EntitySearchHelperService.prototype.deserializeEntities = function (systemName, entitiesDataObservable, compoundMainEntityFields, categoryPermissionTypes) {
        var _this = this;
        var serviceResponse = new response_data_model_1.ResponseData();
        return entitiesDataObservable
            .mergeMap(function (entitiesData) {
            serviceResponse.setTotalRowCount(entitiesData.meta.totalRowCount);
            if (entitiesData.data.length > 0) {
                var entityObservables = (entitiesData.data).map(function (entityData) {
                    return _this.deserializeEntity(systemName, entityData, compoundMainEntityFields, categoryPermissionTypes);
                });
                return Observable_1.Observable.zip.apply(Observable_1.Observable, entityObservables);
            }
            else {
                return Observable_1.Observable.of([]);
            }
        })
            .mergeMap(function (data) {
            serviceResponse.setData(data);
            return Observable_1.Observable.of(serviceResponse);
        });
    };
    EntitySearchHelperService.prototype.deserializeEntitiesNew = function (systemName, entitiesDataObservable, fields, categoryPermissionTypes) {
        var _this = this;
        var languagesObservable = this._languageService.getAvailableLanguages().take(1);
        return languagesObservable.pipe(operators_1.switchMap(function (languages) {
            return entitiesDataObservable.pipe(operators_1.switchMap(function (entitiesData) {
                var serviceResponse = new response_data_model_1.ResponseData();
                serviceResponse.setTotalRowCount(entitiesData.meta.totalRowCount);
                var dataObs;
                if (entitiesData.data.length > 0) {
                    dataObs = _this.collectClassifiers(systemName, entitiesData.data, fields, languages).pipe(operators_1.switchMap(function () {
                        var classifierObservables = [];
                        if (_this.classifiersValueIds.size > 0) {
                            _this.classifiersValueIds.forEach(function (value, key) {
                                if (value.size > 0) {
                                    var classifierData = _this._classifierService.loadClassifiersByIds(key, Array.from(value)).publishReplay(1).refCount().take(1);
                                    classifierObservables.push(classifierData);
                                }
                            });
                            return Observable_1.Observable.zip.apply(Observable_1.Observable, classifierObservables).pipe(operators_1.switchMap(function (loadedClassifiers) {
                                var arr = Array.from(_this.classifiersValueIds.keys());
                                loadedClassifiers.forEach(function (loadedClassifier, index) {
                                    var classifiersArray = loadedClassifier.getData();
                                    var classifiersMap = new Map(classifiersArray.map(function (i) { return [i.getId(), i]; }));
                                    _this.loadedClassifiers.set(arr[index], classifiersMap);
                                });
                                var entityObservables = (entitiesData.data).map(function (entityRow) {
                                    return _this.deserializeEntityNew(systemName, entityRow, languages, fields, categoryPermissionTypes);
                                });
                                return Observable_1.Observable.zip.apply(Observable_1.Observable, entityObservables);
                            }));
                        }
                        else {
                            var entityObservables = (entitiesData.data).map(function (entityRow) {
                                return _this.deserializeEntityNew(systemName, entityRow, languages, fields, categoryPermissionTypes);
                            });
                            return Observable_1.Observable.zip.apply(Observable_1.Observable, entityObservables);
                        }
                    }));
                }
                else {
                    dataObs = Observable_1.Observable.of([]);
                }
                return dataObs.pipe(operators_1.switchMap(function (data) {
                    serviceResponse.setData(data);
                    return Observable_1.Observable.of(serviceResponse);
                }));
            }));
        }));
    };
    EntitySearchHelperService.prototype.deserializeEntity = function (systemName, entityData, compoundMainEntityFields, categoryPermissionTypes) {
        var _this = this;
        var entityFieldsObservable = this._kbService.getMetaFields(systemName);
        var languagesObservable = this._languageService.getAvailableLanguages();
        return Observable_1.Observable.zip(entityFieldsObservable, languagesObservable)
            .mergeMap(function (data) {
            var entityFields = (compoundMainEntityFields === undefined) ? data[0] : compoundMainEntityFields;
            var languages = data[1];
            var entity = _this._entityBuilder.createEntity(main_entity_model_1.MainEntity, entityFields);
            entity = idm_de_core_frontend_1.deserializeSimpleFields(entityFields, languages, entity, entityData);
            return _this.deserializeCompoundFields(systemName, entityFields, entity, entityData, categoryPermissionTypes);
        });
    };
    EntitySearchHelperService.prototype.deserializeEntityNew = function (systemName, entityRow, languages, fieldsToLoad, categoryPermissionTypes) {
        var _this = this;
        if (!this.systemNameMetaFields.get(systemName)) {
            this.systemNameMetaFields.set(systemName, this._kbService.getMetaFields(systemName));
        }
        return this.systemNameMetaFields.get(systemName)
            .pipe(operators_1.switchMap(function (fields) {
            var entityFields;
            if (fieldsToLoad === undefined) {
                entityFields = fields;
            }
            else {
                entityFields = [];
                fieldsToLoad.forEach(function (fieldToLoad) {
                    entityFields.push(fields.filter(function (field) { return field.getSystemName() === fieldToLoad; })[0]);
                });
            }
            var entityRowDraftValues = _this._entityBuilder.createEntity(main_entity_model_1.MainEntity, entityFields);
            var simpleFields = entityFields
                .filter(function (field) {
                return !serialization_helper_1.isCompoundField(field);
            });
            entityRowDraftValues = idm_de_core_frontend_1.deserializeSimpleFields(simpleFields, languages, entityRowDraftValues, entityRow);
            var entityCompoundFields = entityFields
                .filter(function (field) {
                return serialization_helper_1.isCompoundField(field);
            });
            return _this.deserializeCompoundFieldsNew(systemName, entityCompoundFields, entityRowDraftValues, entityRow, languages, categoryPermissionTypes);
        }));
    };
    EntitySearchHelperService.prototype.deserializeCompoundFields = function (systemName, entityFields, entity, entityData, categoryPermissionTypes) {
        var _this = this;
        var entityCompoundFields = entityFields
            .filter(serialization_helper_1.isCompoundField)
            .filter(function (field) {
            return serialization_helper_1.isFieldValueNotEmpty(field, entityData);
        });
        if (entityCompoundFields.length > 0) {
            var entityCompoundFieldObservables = entityCompoundFields
                .map(function (field) {
                return _this.deserializeCompoundField(systemName, field, entityData[field.getSystemName()], categoryPermissionTypes);
            });
            return Observable_1.Observable.zip.apply(Observable_1.Observable, entityCompoundFieldObservables).map(function (fieldValues) {
                entityCompoundFields.forEach(function (field, index) {
                    entity.getProperty(field.getSystemName()).value = fieldValues[index];
                });
                return entity;
            });
        }
        else {
            return Observable_1.Observable.of(entity);
        }
    };
    EntitySearchHelperService.prototype.deserializeCompoundFieldsNew = function (systemName, entityFields, entity, entityRow, languages, categoryPermissionTypes) {
        var _this = this;
        var entityCompoundFields = entityFields
            .filter(function (field) {
            return serialization_helper_1.isFieldValueNotEmpty(field, entityRow);
        });
        if (entityCompoundFields.length > 0) {
            var entityCompoundFieldObservables_1 = [];
            var entityCompoundNotClassifiersField_1 = [];
            entityCompoundFields.forEach(function (field) {
                if (EntitySearchHelperService_1.isClassifier(field) && _this.loadedClassifiers.get(field.getCompoundCategorySystemName())) {
                    if (field.getType() == idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT) {
                        var arr_1 = [];
                        entityRow[field.getSystemName()].forEach(function (eachValue) {
                            if (!_this.loadedClassifiers.get(field.getCompoundCategorySystemName()).get(eachValue)) {
                                entityCompoundNotClassifiersField_1.push(field);
                                entityCompoundFieldObservables_1.push(_this.deserializeCompoundFieldNew(systemName, field, entityRow[field.getSystemName()], languages, categoryPermissionTypes));
                            }
                            else {
                                arr_1.push(_this.loadedClassifiers.get(field.getCompoundCategorySystemName()).get(eachValue));
                            }
                        });
                        entity.getProperty(field.getSystemName()).value = arr_1;
                    }
                    else {
                        if (!_this.loadedClassifiers.get(field.getCompoundCategorySystemName()).get(entityRow[field.getSystemName()])) {
                            entityCompoundNotClassifiersField_1.push(field);
                            entityCompoundFieldObservables_1.push(_this.deserializeCompoundFieldNew(systemName, field, entityRow[field.getSystemName()], languages, categoryPermissionTypes));
                        }
                        else {
                            entity.getProperty(field.getSystemName()).value = _this.loadedClassifiers.get(field.getCompoundCategorySystemName()).get(entityRow[field.getSystemName()]);
                        }
                    }
                }
                else {
                    if (entityRow[field.getSystemName()]) { // TODO @Davit, what about null or undefined fields???
                        entityCompoundNotClassifiersField_1.push(field);
                        entityCompoundFieldObservables_1.push(_this.deserializeCompoundFieldNew(systemName, field, entityRow[field.getSystemName()], languages, categoryPermissionTypes));
                    }
                }
            });
            if (entityCompoundFieldObservables_1.length > 0) {
                return Observable_1.Observable.zip.apply(Observable_1.Observable, entityCompoundFieldObservables_1).map(function (fieldValues) {
                    entityCompoundNotClassifiersField_1.forEach(function (field, index) {
                        // if(!EntitySearchHelperService.isClassifier(field)) {
                        entity.getProperty(field.getSystemName()).value = fieldValues[index];
                        // }
                        if (EntitySearchHelperService_1.isClassifier(field)) {
                            if (!_this.loadedClassifiers.has(field.getCompoundCategorySystemName())) {
                                _this.loadedClassifiers.set(field.getCompoundCategorySystemName(), new Map());
                            }
                            if (field.getType() == idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT) {
                                fieldValues[index].getData().forEach(function (each) {
                                    _this.loadedClassifiers.get(field.getCompoundCategorySystemName()).set(each.getId(), each);
                                });
                            }
                            else {
                                _this.loadedClassifiers.get(field.getCompoundCategorySystemName()).set(fieldValues[index].getId(), fieldValues[index]);
                            }
                        }
                    });
                    return entity;
                });
            }
            else {
                return Observable_1.Observable.of(entity);
            }
        }
        else {
            return Observable_1.Observable.of(entity);
        }
    };
    EntitySearchHelperService.prototype.deserializeCompoundField = function (systemName, field, fieldData, categoryPermissionTypes) {
        var _this = this;
        var fieldType = field.getType();
        switch (fieldType) {
            case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER:
            case idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE: {
                return this._classifierService.loadClassifier(field.getCompoundCategorySystemName(), fieldData).take(1);
            }
            case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY: {
                return this.deserializeCompoundMainEntity(systemName, field, fieldData, categoryPermissionTypes).take(1);
            }
            case idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT:
                var classifierObservables = fieldData.map(function (itemData) {
                    return _this._classifierService.loadClassifierDependencies(field.getCompoundCategorySystemName(), itemData);
                });
                return Observable_1.Observable.zip.apply(Observable_1.Observable, classifierObservables).mergeMap(function (classifierEntities) {
                    return Observable_1.Observable.of(classifierEntities);
                });
            case idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY: {
                var subEntityObservables = fieldData.map(function (itemData) {
                    return _this.deserializeEntity(field.getCompoundCategorySystemName(), itemData, undefined, categoryPermissionTypes);
                });
                return Observable_1.Observable.zip.apply(Observable_1.Observable, subEntityObservables).mergeMap(function (subEntities) {
                    return Observable_1.Observable.of(subEntities);
                });
            }
            case idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING: {
                return Observable_1.Observable.of(fieldData);
            }
            default: {
                throw new Error("Illegal field type " + field.getType() + " was provided.");
            }
        }
    };
    EntitySearchHelperService.prototype.deserializeCompoundFieldNew = function (systemName, field, fieldData, languages, categoryPermissionTypes) {
        var _this = this;
        var fieldType = field.getType();
        switch (fieldType) {
            case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER:
            case idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE: {
                return this._classifierService.loadClassifier(field.getCompoundCategorySystemName(), fieldData).publishReplay(1).refCount().take(1);
            }
            case idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT: {
                return this._classifierService.loadClassifiersByIds(field.getCompoundCategorySystemName(), fieldData).publishReplay(1).refCount().take(1);
            }
            case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY: {
                return this.deserializeCompoundMainEntityNew(systemName, field, fieldData, categoryPermissionTypes);
            }
            case idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY: {
                var subEntityObservables = fieldData.map(function (itemData) {
                    return _this.deserializeEntityNew(field.getCompoundCategorySystemName(), itemData, languages, undefined, categoryPermissionTypes);
                });
                return Observable_1.Observable.zip.apply(Observable_1.Observable, subEntityObservables).mergeMap(function (subEntities) {
                    return Observable_1.Observable.of(subEntities);
                });
            }
            case idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING: {
                return Observable_1.Observable.of(fieldData);
            }
            default: {
                throw new Error("Illegal field type " + field.getType() + " was provided.");
            }
        }
    };
    EntitySearchHelperService.prototype.deserializeCompoundMainEntity = function (systemName, field, fieldData, categoryPermissionTypes) {
        var _this = this;
        var metaFields$ = this._kbService.getMetaFields(field.getCompoundCategorySystemName());
        var compoundMainEntityMetaFields$ = this._kbService.getMainEntityMetaFields(systemName, field.getSystemName());
        return Observable_1.Observable.zip(metaFields$, compoundMainEntityMetaFields$)
            .mergeMap(function (data) {
            var metaFieldSystemName;
            data[0].forEach(function (metaField) {
                if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE) {
                    metaFieldSystemName = metaField.getSystemName();
                }
            });
            if (metaFieldSystemName !== undefined && metaFieldSystemName !== null) {
                var filterBuilder = new idm_de_core_frontend_1.FilterBuilder();
                if (Array.isArray(fieldData)) {
                    filterBuilder.in(metaFieldSystemName, fieldData);
                }
                else {
                    filterBuilder.is(metaFieldSystemName, fieldData);
                }
                var mainEntityItems$ = _this._entitySearchService.loadPortfolioItems(field.getCompoundCategorySystemName(), new idm_de_core_frontend_1.PagingOptions(0, 1), null, filterBuilder.build().toJson(), categoryPermissionTypes, data[1]);
                return mainEntityItems$.map(function (value) {
                    return value.getData().length > 0 ? value.getData()[0] : null;
                });
            }
            else {
                return Observable_1.Observable.of(null);
            }
        });
    };
    EntitySearchHelperService.prototype.deserializeCompoundMainEntityNew = function (systemName, field, fieldData, categoryPermissionTypes) {
        var _this = this;
        var fieldSystemName = field.getSystemName();
        var fieldCompoundCategorySystemName = field.getCompoundCategorySystemName();
        //cache of mainEntityMetaFields
        var compoundMainEntityMetaFieldsMap = this.compoundMainEntityMetaFieldsMap.get(systemName);
        if (compoundMainEntityMetaFieldsMap) {
            if (!compoundMainEntityMetaFieldsMap.get(field.getSystemName())) {
                compoundMainEntityMetaFieldsMap.set(field.getSystemName(), this._kbService.getMainEntityMetaFields(systemName, field.getSystemName()));
            }
        }
        else {
            compoundMainEntityMetaFieldsMap = new Map();
            compoundMainEntityMetaFieldsMap.set(field.getSystemName(), this._kbService.getMainEntityMetaFields(systemName, field.getSystemName()));
            this.compoundMainEntityMetaFieldsMap.set(systemName, compoundMainEntityMetaFieldsMap);
        }
        return compoundMainEntityMetaFieldsMap.get(field.getSystemName())
            .mergeMap(function (compoundMainEntityMetaFields) {
            var mainEntityIntegerInstance;
            for (var i = 0; i < compoundMainEntityMetaFields.length; i++) {
                if (compoundMainEntityMetaFields[i].getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE) {
                    mainEntityIntegerInstance = compoundMainEntityMetaFields[i].getSystemName();
                    break;
                }
            }
            if (mainEntityIntegerInstance !== undefined && mainEntityIntegerInstance !== null) {
                var currentMainEntityItems$ = void 0;
                var filterBuilder = new idm_de_core_frontend_1.FilterBuilder();
                filterBuilder.is(mainEntityIntegerInstance, fieldData);
                var currentCategoryAllMainEntityDeSerializedValues = _this.mainEntityDeSerializedData.get(fieldSystemName);
                if (currentCategoryAllMainEntityDeSerializedValues) {
                    currentMainEntityItems$ = currentCategoryAllMainEntityDeSerializedValues.get(fieldData);
                    if (!currentMainEntityItems$) {
                        currentMainEntityItems$ = _this._entitySearchService.loadPortfolioItemsByFields(fieldCompoundCategorySystemName, new idm_de_core_frontend_1.PagingOptions(0, 1), null, filterBuilder.build().toJson(), undefined, categoryPermissionTypes).publishReplay(1).refCount().take(1);
                        currentCategoryAllMainEntityDeSerializedValues.set(fieldData, currentMainEntityItems$);
                    }
                }
                else {
                    currentMainEntityItems$ = _this._entitySearchService.loadPortfolioItemsByFields(fieldCompoundCategorySystemName, new idm_de_core_frontend_1.PagingOptions(0, 1), null, filterBuilder.build().toJson(), undefined, categoryPermissionTypes).publishReplay(1).refCount().take(1);
                    currentCategoryAllMainEntityDeSerializedValues = new Map();
                    currentCategoryAllMainEntityDeSerializedValues.set(fieldData, currentMainEntityItems$);
                    _this.mainEntityDeSerializedData.set(fieldSystemName, currentCategoryAllMainEntityDeSerializedValues);
                }
                return currentMainEntityItems$.map(function (value) {
                    return value.getData().length > 0 ? value.getData()[0] : null;
                });
            }
            else {
                return Observable_1.Observable.of(null);
            }
        });
    };
    /**
     * returned result will be like this: nameMetaFields separated by '|' then ':' then filter fields separated by ','. Exp (name1|name2: filter1,filter2)
     */
    EntitySearchHelperService.prototype.getEntityDisplayNameFromResponse = function (entitiesData, filterFields, multilingualFields, nameFieldIds, languageId, categoryIdentityFieldSystemName) {
        var searchItems;
        searchItems = entitiesData.map(function (entityItem) {
            var copiedFilterFields = filterFields.slice(0); //to avoid that filterFields will crash in component, because reference is passed to this method
            //collect name fields
            var nameFields = [];
            nameFieldIds.forEach(function (nameMetaFieldId) {
                var nameFieldSystemName = nameMetaFieldId.getSystemName();
                var indexOfFilterableFieldInNameFieldsList = copiedFilterFields.indexOf(nameFieldSystemName);
                if (indexOfFilterableFieldInNameFieldsList > -1) {
                    copiedFilterFields.splice(indexOfFilterableFieldInNameFieldsList, 1); // remove from filterableFields, to avoid collecting the same text twice
                }
                nameFields.push((multilingualFields.indexOf(nameFieldSystemName) > -1 ? entityItem[nameFieldSystemName][languageId] : entityItem[nameFieldSystemName]));
            });
            //collect filterable fields
            var filterFieldData = copiedFilterFields.map(function (filterField) {
                return multilingualFields.indexOf(filterField) > -1 ? entityItem[filterField][languageId] : entityItem[filterField];
            });
            //concat name and filterable fields
            var displayNameStartsWith = "";
            nameFields.forEach(function (nameField) {
                displayNameStartsWith = displayNameStartsWith.concat(nameField).concat(" | ");
            });
            if (displayNameStartsWith.length > 0) {
                displayNameStartsWith = displayNameStartsWith.slice(0, -3) + " : ";
            }
            return new entity_search_item_1.EntitySearchItem(entityItem[categoryIdentityFieldSystemName], filterFieldData.length > 0 ? displayNameStartsWith.concat(filterFieldData.join(" , ")) : displayNameStartsWith.slice(0, -3), //remove ':' if the only one filterable field is namefield
            entityItem);
        });
        return searchItems;
    };
    EntitySearchHelperService.prototype.collectClassifiers = function (systemName, entityAllRows, fieldsToLoad, languages) {
        var _this = this;
        if (!this.systemNameMetaFields.get(systemName)) {
            this.systemNameMetaFields.set(systemName, this._kbService.getMetaFields(systemName));
        }
        return this.systemNameMetaFields.get(systemName).pipe(operators_1.switchMap(function (metaFields) {
            var entityFields;
            if (fieldsToLoad === undefined) {
                entityFields = metaFields;
            }
            else {
                entityFields = [];
                fieldsToLoad.forEach(function (fieldToLoad) {
                    entityFields.push(metaFields.filter(function (metaField) { return metaField.getSystemName() === fieldToLoad; })[0]);
                });
            }
            entityAllRows.map(function (entityRowData) {
                entityFields.map(function (entityField) {
                    if (serialization_helper_1.isCompoundField(entityField) && serialization_helper_1.isFieldValueNotEmpty(entityField, entityRowData)) {
                        var fieldType = entityField.getType();
                        switch (fieldType) {
                            case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER:
                            case idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE: {
                                var classifierValues = _this.classifiersValueIds.get(entityField.getCompoundCategorySystemName());
                                if (!classifierValues) {
                                    classifierValues = new Set();
                                }
                                if (entityRowData[entityField.getSystemName()]) {
                                    classifierValues.add(entityRowData[entityField.getSystemName()]);
                                }
                                _this.classifiersValueIds.set(entityField.getCompoundCategorySystemName(), classifierValues);
                                break;
                            }
                            case idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT: {
                                var classifierValues_1 = _this.classifiersValueIds.get(entityField.getCompoundCategorySystemName());
                                if (!classifierValues_1) {
                                    classifierValues_1 = new Set();
                                }
                                if (entityRowData[entityField.getSystemName()]) {
                                    entityRowData[entityField.getSystemName()].forEach(function (item) {
                                        classifierValues_1.add(item);
                                    });
                                }
                                _this.classifiersValueIds.set(entityField.getCompoundCategorySystemName(), classifierValues_1);
                                break;
                            }
                        }
                    }
                });
            });
            return Observable_1.Observable.of({});
        }));
    };
    EntitySearchHelperService.isClassifier = function (field) {
        var fieldType = field.getType();
        return fieldType === idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER || fieldType === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE || fieldType === idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT;
    };
    EntitySearchHelperService = EntitySearchHelperService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_message_language_service_client_js_1.LanguageService,
            idm_classifier_service_client_js_1.ClassifierService,
            entity_service_1.EntitySearchService])
    ], EntitySearchHelperService);
    return EntitySearchHelperService;
    var EntitySearchHelperService_1;
}());
exports.EntitySearchHelperService = EntitySearchHelperService;
//# sourceMappingURL=entity-helper.service.js.map